// SourceDropOverlay — the full-window "drop to add" echo, pure.
//
// Rendered by the host while an OS file drag hovers the window (the host's
// window-level listeners own the impure gesture; this is only its calm
// visual). `pointer-events: none` so the drop lands on those listeners, not
// on this layer. `aria-hidden` because the accessible ingest path is the
// "Add source" picker and progress is announced by the rail's status line —
// the overlay is a pointer-gesture echo, not an announcement surface.

import { useLingui } from "@lingui/react/macro";
import "./SourceDropOverlay.css";

export type SourceDropOverlayProps = {
    // Where the dropped files will land — the workspace's name.
    readonly workspaceName: string;
};

export const SourceDropOverlay = ({
    workspaceName,
}: SourceDropOverlayProps) => {
    const { t } = useLingui();
    return (
        <div className="bilda-source-drop-overlay" aria-hidden="true">
            <div className="bilda-source-drop-overlay__card">
                <p className="bilda-source-drop-overlay__title">
                    {t`Drop to add as a source`}
                </p>
                <p className="bilda-source-drop-overlay__hint">
                    {t`The files join ${workspaceName}`}
                </p>
            </div>
        </div>
    );
};
